module.exports = "/fonts/fa-solid-900.woff?bea989e82b07e9687c26fc58a4805021";